export default "__VITE_ASSET__Czj2mhvF__"